import React, { Component } from 'react';
import '../css/getEditDatosCliente.css';
import 'whatwg-fetch'; 
class getEditDatosCliente extends Component {

  constructor(){
    super();
    this.state = {
        lista_alias : [],
        alias:'',
        accion :'',
        nombre:'',
        ruc:'',
        telefono:'',
        direccion:'',
        email:'',
        msg:'',
        msg_loading :false,
        id_datos_facturacion_update :0
    }
  }

  getnewdatosFacturacion =()=>{
    let accion = this.state.accion
    if(accion===''){
      this.setState({
        accion :'newdatosfacturacion',
        alias:'',
        nombre:'',
        ruc:'',
        telefono:'',
        direccion:'',
        email:'',
        msg:'',
        id_datos_facturacion_update :0
      })
    }else{
      this.setState({
        accion :''
      })
    }
  }
  inputChangedHandlerText1 = (event) => {
    this.setState({
      alias :event.target.value
    })
  }
  inputChangedHandlerText2 = (event) => {
    this.setState({
      nombre :event.target.value
    })
  }
  inputChangedHandlerText3 = (event) => {
    this.setState({
      ruc :event.target.value
    })
  }
  inputChangedHandlerText4 = (event) => {
    this.setState({
      telefono :event.target.value
    })
  }
  inputChangedHandlerText5 = (event) => {
    this.setState({
      direccion :event.target.value
    })
  }
  inputChangedHandlerText6 = (event) => {
    this.setState({
      email :event.target.value
    })
  }

  validateEmail = (email) => {
      return /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test(email)
  }
  getnewAlias =(accion)=>{
      const alias = this.state.alias.trim()
      const nombre = this.state.nombre.trim()
      const ruc = this.state.ruc.trim()
      const telefono = this.state.telefono.trim()
      const direccion = this.state.direccion.trim()
      const email = this.state.email.trim()
      let id_datos_facturacion_update = this.state.id_datos_facturacion_update
      if(alias.trim()===''){
        this.setState({
          msg : "Ingrese Alias"
        })
        return
      }
      if(nombre.trim()===''){
        this.setState({
          msg : "Ingrese Razón Social / Nombre"
        })
        return
      }
      if(ruc.trim()===''){
        this.setState({
          msg : "Ingrese RUC / Cédula / Pasaporte"
        })
        return
      }
      //console.log(this.validateCodigo(ruc))

      if(!this.validateCodigo(ruc)){
        this.setState({
          msg : " RUC / Cédula / Pasaporte Incorrecto"
        })
        return
      }

      if(telefono.trim()===''){
        this.setState({
          msg : "Ingrese Teléfono"
        })
        return
      }
      if(direccion.trim()===''){
        this.setState({
          msg : "Ingrese Dirección"
        })
        return
      }
      if(email.trim()===''){
        this.setState({
          msg : "Ingrese Mail"
        })
        return
      }
      if(!this.validateEmail(email)){
        this.setState({
          msg : "Mail Incorrecto"
        })
        return
      }

      if(accion==="new"){
        id_datos_facturacion_update=0
      }

      const url= this.props.dir_url + "webapp/getsavenewalias";
      const token =  this.props.token
      const token_Client =  this.props.token_Client
      var obj = { accion:'savenewalias', token, token_Client,alias,nombre,ruc,telefono,direccion,email,id_datos_facturacion_update};
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(obj),
        headers:{
          'Accept':'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.json())
      .then((data) => {
        if(data[0].status==="ok"){
          this.setState({
            accion :''
          },()=>{
            //this.get_Forma_Datos_Cliente()
            this.props.get_go_to_sub("")
          })
          this.get_loading(false)
        }
      })
      .catch(console.log)
      this.get_loading(true)
  }

  get_loading =(msg_loading)=>{
    this.setState({
      msg_loading
    })
  }

  get_Forma_Datos_Cliente =()=>{
    const url= this.props.dir_url + "webapp/getDatosFormaClient";
    const token =  this.props.token
    const token_Client =  this.props.token_Client
    var obj = { accion:'datosformaclient', token, token_Client};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          lista_alias : data[0].msg
        })
      }else{
        this.setState({
          lista_alias : []
        })
      }
    })
    .catch(console.log)
  }

  getupdatedefaultDatosClientes =(id_datos_facturacion)=>{
      if(Number(id_datos_facturacion)>0){
        const url= this.props.dir_url + "webapp/getupdatedefaultDatosClientes";
        const token =  this.props.token
        const token_Client =  this.props.token_Client
        var obj = { accion:'updatedefaultDatosClientes', token, token_Client,id_datos_facturacion};
        fetch(url, {
          method: 'POST',
          body: JSON.stringify(obj),
          headers:{
            'Accept':'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(res => res.json())
        .then((data) => {
          if(data[0].status==="ok"){
            //this.get_Forma_Datos_Cliente()
            this.props.get_go_to_sub("")
          }

        })
        .catch(console.log)
      }
  }
  geteditdefaultDatosClientes =(id_datos_facturacion)=>{
    const url= this.props.dir_url + "webapp/getdataDatosClientes";
    const token =  this.props.token
    const token_Client =  this.props.token_Client
    var obj = { accion:'datadatosclientes', token, token_Client,id_datos_facturacion};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          alias: data[0].msg[0].alias,
          accion :'editdatosfacturacion',
          nombre: data[0].msg[0].razon_social,
          ruc: data[0].msg[0].ruc,
          telefono: data[0].msg[0].telefono,
          direccion: data[0].msg[0].direccion,
          email: data[0].msg[0].correo_electronico,
          msg:'',
          id_datos_facturacion_update :data[0].msg[0].id_datos_facturacion
        })
      }
      this.get_loading(false)
    })
    .catch(console.log)
    this.get_loading(true)
  }
  validateCodigo =(codigo)=>{
    if(codigo){
      const len_string= codigo.length
      if(len_string>3&&len_string<=20){
        const ext = codigo.substring(len_string-2, len_string).trim();
        if(ext.toUpperCase()==='EX'){
          return 2;
        }
      }
      if(len_string===10){
        if(codigo==='9999999999'){
          return false
        }
      }
      if(len_string===13){
        if(codigo==='9999999999999'){
          return false
        }
        const ext = codigo.substring(len_string-3, len_string).trim()
        if(ext!=='001'){
          return false;
        }
      }
      let sum_pa=0
      let sum_im=0
      for(var i=1;i<9;i=i+2){
          sum_pa = Number(codigo.substring(i, i+1)) + sum_pa
      }
      for(var i=0;i<9;i=i+2){
          let valor = Number(codigo.substring(i, i+1))*2
          if(valor>9){
            valor=valor-9
          }
          sum_im=sum_im+valor
      }
      let  tot=sum_pa+sum_im
      while(tot>10){
              tot=tot-10;
      }
 	    tot=10-tot
      const ult_dig= Number(codigo.substring(9,10))
    	if (tot==ult_dig){
        if(len_string===13){
          return 1
        }else{
          if(len_string===10){
            return 2
          }else{
            return false
          }
        }
      }else{

    	}
      if((Number(codigo.substring(2,3))===6||Number(codigo.substring(2,3))===9)&&len_string===13){
        return 1
      }

      return false

    }else{
      return false
    }
  }
  getdeletedefaultDatosClientes =(id_datos_facturacion,por_defecto)=>{

      const url= this.props.dir_url + "webapp/getdeletedefaultDatosClientes";
      const token =  this.props.token
      const token_Client =  this.props.token_Client
      var obj = { accion:'deletedefaultDatosClientes', token, token_Client,id_datos_facturacion,por_defecto};
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(obj),
        headers:{
          'Accept':'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.json())
      .then((data) => {
        //if(data[0].status==="ok"){
          //this.get_Forma_Datos_Cliente()
          this.props.get_go_to_sub("")
        //}

      })
      .catch(console.log)
  }
getllenarDatosClientes =()=>{
  //id_datos_facturacion, id_cliente, razon_social, ruc, telefono, direccion, correo_electronico, eliminado, uuid_cliente, alias, por_defecto
  const lista_alias = this.state.lista_alias
  return (
    <React.Fragment>
    {lista_alias.map(alias => (
      <div key={alias.id_datos_facturacion} className="grid-container-menu_list-datos_clientes_der" >
        <div className="div_menu_1_list-datos_clientes_der"  onClick={ () => this.geteditdefaultDatosClientes(alias.id_datos_facturacion)}>
          <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
        </div>
        <div className="lbl_menu_2_list-datos_clientes_der"  onClick={ () => this.getdeletedefaultDatosClientes(alias.id_datos_facturacion,alias.por_defecto)}>
          <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/14458160321582004493-128.png') } />
        </div>
        <div className="lbl_menu_3_list-datos_clientes_der" onClick={ () => this.getupdatedefaultDatosClientes(alias.id_datos_facturacion)}>
         {alias.alias}
        </div>
        <div className="lbl_menu_4_list-datos_clientes_der" onClick={ () => this.getupdatedefaultDatosClientes(alias.id_datos_facturacion)}>
          {(Number(alias.id_datos_facturacion)===Number(alias.por_defecto))?
          <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/7774226221582004489-128.png') } />
          :''
        }
        </div>
      </div>
    )) }
    </React.Fragment>
  )
}

  getListaFichaNuevoDatosClientes =()=>{
    const accion = this.state.accion
    //id_datos_facturacion, id_cliente, razon_social, ruc, telefono, direccion, correo_electronico, eliminado, uuid_cliente, alias
    return (
      <React.Fragment>
        <div className="grid-container-menu_list-datos_clientes">
          <div className="div_menu_1_list-datos_clientes">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } />
          </div>
          <div className="lbl_menu_2_list-datos_clientes">
            <input style={{"width":"100%"}} value={this.state.alias} onChange={(event)=>this.inputChangedHandlerText1(event)} className="input-global" placeholder="Alias" />
          </div>
        </div>
        <div className="grid-container-menu_list-datos_clientes">
          <div className="div_menu_1_list-datos_clientes">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') } />
          </div>
          <div className="lbl_menu_2_list-datos_clientes">
            <input style={{"width":"100%"}} value={this.state.nombre} onChange={(event)=>this.inputChangedHandlerText2(event)} className="input-global" placeholder="Razón Social / Nombre" />
          </div>
        </div>
        <div className="grid-container-menu_list-datos_clientes">
          <div className="div_menu_1_list-datos_clientes">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/4798580041582004495-128.png') } />
          </div>
          <div className="lbl_menu_2_list-datos_clientes">
            <input style={{"width":"100%"}} value={this.state.ruc} onChange={(event)=>this.inputChangedHandlerText3(event)} className="input-global" placeholder="RUC / Cédula / Pasaporte" />
          </div>
        </div>
        <div className="grid-container-menu_list-datos_clientes">
          <div className="div_menu_1_list-datos_clientes">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/9180212681582004495-128.png') } />
          </div>
          <div className="lbl_menu_2_list-datos_clientes">
            <input style={{"width":"100%"}} value={this.state.telefono} onChange={(event)=>this.inputChangedHandlerText4(event)} className="input-global" placeholder="Teléfono" />
          </div>
        </div>
        <div className="grid-container-menu_list-datos_clientes">
          <div className="div_menu_1_list-datos_clientes">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/9478791231582004484-128.png') } />
          </div>
          <div className="lbl_menu_2_list-datos_clientes">
            <input style={{"width":"100%"}} value={this.state.direccion} onChange={(event)=>this.inputChangedHandlerText5(event)} className="input-global" placeholder="Dirección" />
          </div>
        </div>
        <div className="grid-container-menu_list-datos_clientes">
          <div className="div_menu_1_list-datos_clientes">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') } />
          </div>
          <div className="lbl_menu_2_list-datos_clientes">
            <input style={{"width":"100%"}} value={this.state.email} onChange={(event)=>this.inputChangedHandlerText6(event)} className="input-global" placeholder="Email" />
          </div>
        </div>
        <br/>
          <span style={{"color":"red"}}>{this.state.msg}</span>
        <br/>
        <div  className="div_global_registre_title-datos_clientes" >
          {(accion==="editdatosfacturacion")?
            <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getnewAlias('edit')}>
            EDITAR ALIAS
            </button>
            :
            <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getnewAlias('new')}>
            CREAR ALIAS
            </button>
          }
        </div>
      </React.Fragment>
    )
  }
  render() {

    const msg_loading = this.state.msg_loading
    let modal_loading
    if(msg_loading){
      modal_loading = <div id="loader" className="loader loader-default is-active" data-text=""></div>
    }
    let ficha_nueva_forma_pago
    const accion = this.state.accion
    if(accion==="newdatosfacturacion"){
      ficha_nueva_forma_pago =  <React.Fragment>{this.getListaFichaNuevoDatosClientes()}</React.Fragment>
    }

    if(accion==="editdatosfacturacion"){
      ficha_nueva_forma_pago =  <React.Fragment>{this.getListaFichaNuevoDatosClientes()}</React.Fragment>
    }

    return (
      <div className="modal-dialog-datos_clientes">
      <div className="modal-content-datos_clientes">
        <div className="grid-container-menu_list-datos_clientes">
          <div className="div_menu_1_list-datos_clientes">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } onClick={ () => this.props.get_go_to_sub("")} />
          </div>
          <div className="lbl_menu_2_list-datos_clientes">
            <span className="span-global-link">Elija Datos para Facturación</span>
          </div>
        </div>
        {this.getllenarDatosClientes()}
        <div className="grid-container-menu_list-datos_clientes_izq"  onClick={ () => this.getnewdatosFacturacion()}>
          <div className="div_menu_1_list-datos_clientes_izq">
            Añadir Datos para Facturación
          </div>
          <div className="lbl_menu_2_list-datos_clientes_izq">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12817025351582004496-128.png') } />
          </div>
        </div>
        {ficha_nueva_forma_pago}
      </div>
      {modal_loading}
      </div>
    );
  }
  componentDidMount (){
    this.get_Forma_Datos_Cliente();
  }
}
export default getEditDatosCliente;
